import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import DataTableActions from '@/components/datatable/DataTableActions.vue';
    import { EmployeeOptional } from '@/types';
    import { usePermissions } from '@/composables/usePermissions';
    import Permission from '@/enums/Permission';
    import EditEmployeeOptional from '@/components/employee-optionals/EditEmployeeOptional.vue';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'EmployeeOptionalsTableActions',
  props: {
    employeeOptional: {}
  },
  setup(__props: any) {

    

    const { hasPermission } = usePermissions();

return (_ctx: any,_cache: any) => {
  return (_unref(hasPermission)(_unref(Permission).SALARY_COMPANY_UPDATE))
    ? (_openBlock(), _createBlock(DataTableActions, {
        key: 0,
        data: _ctx.employeeOptional
      }, {
        default: _withCtx(() => [
          _createVNode(EditEmployeeOptional, { "employee-optional": _ctx.employeeOptional }, null, 8, ["employee-optional"])
        ]),
        _: 1
      }, 8, ["data"]))
    : _createCommentVNode("", true)
}
}

})